import { validate as isUuid } from 'uuid';
import { titleCase } from '@/utils/string';

export interface Crumb {
  title: string;
  to: string;
}

const TITLE_OVERRIDES: Record<string, string> = {
  '/devops': 'DevOps',
  '/devops/questdb': 'QuestDB',
  '/treasury/kx': 'JPM Kinexys',
  '/compliance/fiu-utr': 'FIU UTR Filing',
  '/operations/mm-programs': 'MM Programs',
};

// Path segments whose page no longer exists — the crumb links somewhere useful instead.
const REDIRECTS: Record<string, Crumb> = {
  '/operations/users': { title: 'User Search', to: '/operations/user-search' },
};

export const deriveBreadcrumbs = (pathname: string): Crumb[] => {
  if (pathname === '/') return [];

  const crumbs: Crumb[] = [{ title: 'Home', to: '/' }];
  let path = '';
  for (const segment of pathname.split('/').filter(Boolean)) {
    path += `/${segment}`;
    const redirect = REDIRECTS[path];
    if (redirect) {
      crumbs.push(redirect);
      continue;
    }
    // Raw UUIDs (user PIDs, broker ids, …) are shown as-is
    const title = TITLE_OVERRIDES[path] ?? (isUuid(segment) ? segment : titleCase(segment));
    crumbs.push({ title, to: path });
  }
  return crumbs;
};
